import { ReadonlyMat3, ReadonlyMat4 } from 'gl-matrix';
import { gl } from '../../../Engine';
import { Uniform } from './Uniform';

export class UniformMatrix extends Uniform {
    constructor(name: string) {
        super(name);
    }

    loadMatrix(
        matrix: ReadonlyMat4 | ReadonlyMat3 | Array<number>,
        transpose = false
    ) {
        if (this.location) {
            if (matrix.length === 16) {
                gl.uniformMatrix4fv(this.location, transpose, matrix, 0, 16);
            } else if (matrix.length === 9) {
                gl.uniformMatrix3fv(this.location, transpose, matrix, 0, 9);
            } else {
                throw new Error(
                    `Attempting to load Matrix with invalid size of ${matrix.length} onto uniform variable ${this.name}`
                );
            }
        }
    }
}
